export const landslide = {
  name: `landslide`,
  sql: `
    SELECT * FROM solano_ls
    WHERE haz_ls IN ('High', 'Medium', 'Low')
    `,
    cartoCSS: `
    #layer {
      polygon-fill: ramp([haz_ls], (#C4385B, #CE8399, #7EFBDF), ("High", "Medium", "Low"), =);
      polygon-opacity: 0.5;
      polygon-comp-op: multiply;
    }
    #layer::outline {
        line-width: 0;
        line-color: #FFFFFF;
        line-opacity: 0.5;
    }
  `,
  viz: `
    color: ramp(buckets($haz_ls, ["High", "Medium", "Low"]), [opacity(#7EFBDF, 0.5),opacity(#CE8399, 0.5), opacity(#C4385B, 0.5)])
    strokeWidth: 0
    `
}